import React, { Component } from 'react';
import { Box, Typography } from '@material-ui/core';
import TabsContent from '../../../commonModules/interface/TabsContent';
import IntegrationsTab from './IntegrationsTab';

/**
 * Page Paramètres — accessible depuis le menu AdminDashboard (entrée "settings").
 * Gating admin (role != 0) appliqué dans AdminDashboard avant le rendu.
 * Onglets : Intégrations (Prospect Energy ; e-MECeF viendra se brancher ici plus tard).
 */
class Settings extends Component {
    render() {
        return (
            <Box p={2}>
                <Typography variant="h5" gutterBottom>
                    Paramètres
                </Typography>
                {/* TabsContent affiche children[value] : avec un seul onglet, children doit
                    rester un tableau, sinon children[0] est undefined et le panneau est vide. */}
                <TabsContent
                    labels={['Intégrations']}
                >
                    {[<IntegrationsTab key="integrations" />]}
                </TabsContent>
            </Box>
        );
    }
}

export default Settings;
